module.exports = __webpack_public_path__ + "img/更新到器件库2.36f798d9.svg";